const sections = new WeakMap();

function initialize(root) {
  if (sections.has(root)) return;
  const form = root.querySelector('form.dnd-product-form');
  const picker = root.querySelector('.dnd-pack-picker');
  const copyNode = root.querySelector('[data-dnd-purchase-copy]');
  if (!form || !picker || !copyNode) return;

  const copy = JSON.parse(copyNode.textContent);
  const controller = new AbortController();
  sections.set(root, controller);
  const cards = Array.from(picker.querySelectorAll('.dnd-pack-card'));
  const radios = Array.from(root.querySelectorAll('input[data-dnd-purchase-mode]'));
  const variantInput = form.querySelector('input[name="id"]');
  const planInput = form.querySelector('input[name="selling_plan"]');
  const submit = form.querySelector('button[type="submit"]');
  const gifts = root.querySelector('.dnd-free-gifts');
  const status = root.querySelector('[data-dnd-purchase-status]');
  let selected = cards.find(card => card.getAttribute('aria-pressed') === 'true') || cards[0];

  function update() {
    if (!selected) return;
    const subscription = radios.find(radio => radio.checked)?.value !== 'one-time';
    form.dataset.dndPurchaseMode = subscription ? 'subscription' : 'one-time';
    const ready = selected.dataset.oneTimeReady === 'true';
    form.dataset.dndOneTimeReady = String(ready);

    for (const card of cards) {
      const active = card === selected;
      card.classList.toggle('is-active', active);
      card.setAttribute('aria-pressed', String(active));
      card.querySelector('.dnd-pack-card__price').textContent = subscription ? card.dataset.subscriptionPrice : card.dataset.oneTimePrice;
    }
    for (const radio of radios) {
      radio.closest('.dnd-recharge-choice').classList.toggle('is-selected', radio.checked);
    }

    variantInput.value = selected.dataset.packVariantId || '';
    if (planInput) {
      planInput.value = subscription ? selected.dataset.subscriptionPlan || '' : '';
      planInput.disabled = !subscription;
    }
    const available = selected.dataset.packAvailable === 'true';
    const valid = Boolean(variantInput.value && available && (subscription ? planInput?.value : ready));
    submit.disabled = !valid;
    submit.querySelector('[data-dnd-submit-label]').textContent = available ? copy.checkout : copy.soldOut;

    root.querySelector('[data-dnd-subscription-price]').textContent = selected.dataset.subscriptionPrice;
    root.querySelector('[data-dnd-one-time-price]').textContent = selected.dataset.oneTimePrice;
    root.querySelector('[data-dnd-billing-detail]').textContent = subscription ? copy.monthlyBilling : copy.payOnce;
    root.querySelector('[data-dnd-pack-note]').textContent = subscription ? copy.monthlyNote : copy.oneTimeNote;
    root.querySelector('[data-dnd-after-cta]').textContent = subscription ? copy.afterSubscription : copy.afterOneTime;
    if (gifts) gifts.hidden = !subscription;
    status.hidden = subscription || ready;
    status.textContent = subscription || ready ? '' : copy.oneTimeUnavailable;
    const feedback = form.querySelector('[data-dnd-checkout-error]');
    if (feedback) feedback.hidden = true;
  }

  picker.addEventListener('click', event => {
    const card = event.target.closest('.dnd-pack-card');
    if (!card || !picker.contains(card)) return;
    selected = card;
    update();
  }, { signal: controller.signal });

  for (const radio of radios) radio.addEventListener('change', update, { signal: controller.signal });
  window.addEventListener('pageshow', update, { signal: controller.signal });
  update();
}

document.querySelectorAll('[data-dnd-purchase-section]').forEach(initialize);
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('[data-dnd-purchase-section]').forEach(initialize);
});
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('[data-dnd-purchase-section]').forEach(root => {
    sections.get(root)?.abort();
    sections.delete(root);
  });
});
